//import { Directive } from '@angular/core';
import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  //selector: '[appMobileNumber]'
  selector: 'input[MobileNumber]',
  standalone: true
})
export class MobileNumberDirective {
  private control: NgControl;
  constructor(private _el: ElementRef) {
    debugger
  }
  @HostListener('input', ['$event']) onInputChange(event: FocusEvent) {
    debugger
    const initalValue = this._el.nativeElement.value;
    this._el.nativeElement.value = initalValue.replace(
      /[A-z;~`\/|:'",<.>?!@#$%^&*_={}[]]*$/g,
      ''
    );
    if (initalValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }
  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent): void {
    debugger
    const initalValue = event.dataTransfer?.getData('text');
    if (initalValue)
    this.handleEvent(initalValue);
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    debugger
    const initalValue = event.clipboardData?.getData('text/plain')
    if (initalValue)
    this.handleEvent(initalValue);
  }

  handleEvent(input: string): void {
    debugger
    if (!this.isValidInput(input)) {
      // Prevent the default behavior (e.g., dropping or pasting invalid characters)
      event?.preventDefault();
    }
  }

  isValidInput(value: string): boolean {
    // Define your regex pattern
    debugger
    const regexPattern = /^[0-9 ()-]*$/;
    return regexPattern.test(value);
  }
}

